export class MathHelper {
    private static prevUniqueNum: number;

    public static randomNumberInRange(min: number, max: number, decimals: number = 0): number {
        let randomNumber: number = min + (max - min) * Math.random();
        return Number(randomNumber.toFixed(decimals));
    }

    public static roundToDecimals(num: number, noOfDecimals: number): number {
        return Number((num).toFixed(noOfDecimals));
    }

    public static uniqueNumberInRange(min: number, max: number, decimals: number = 0): number {
        if ((min === max) || (min > max)) { //min > max condition added because of blank array and it's length - 1
            return min;
        } else {
            let randomNumber: number = Number((min + (max - min) * Math.random()).toFixed(decimals));
            if (this.prevUniqueNum === randomNumber) {
                randomNumber = this.uniqueNumberInRange(min, max, decimals);
            }
            this.prevUniqueNum = randomNumber;
            return randomNumber;
        }
    }

    public static getTimeStamp(): string {
        const today: Date = new Date();
        return today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds() + ":" + today.getMilliseconds();
    }

    /**
     * Returns angle between two points in radians.
     * @param p1 first point
     * @param p2 second point
     * @returns {number} Angle
     */
    static angleBetweenPoints(p1: PIXI.Point, p2: PIXI.Point): number {
        return Math.atan2(p2.y - p1.y, p2.x - p1.x);
    }

    /**
     * Returns distance between two points.
     * @param p1 first point
     * @param p2 second point
     * @returns {number} Distance
     */
    static distanceBetweenPoints(p1: PIXI.Point, p2: PIXI.Point) {
        return Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
    }
}